module.exports = __webpack_public_path__ + "static/media/education.8ce46392.svg";